import { Component, OnInit, OnDestroy } from '@angular/core';
import {jwtDecode} from 'jwt-decode'; // Correct import for jwtDecode
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { interval, Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  userInfo: any;
  private tokenCheckSubscription: Subscription;
  private lastToken: string | null = null;
  isLoadingProfile: boolean = true;

  constructor(private router: Router, private apiService: ApiService, private AuthService:AuthService) {}

  ngOnInit(): void {
    this.startTokenCheck();
  }

  ngOnDestroy(): void {
    if (this.tokenCheckSubscription) {
      this.tokenCheckSubscription.unsubscribe(); // Cleanup on destroy
    }
  }

  startTokenCheck(): void {
    this.tokenCheckSubscription = interval(1000).subscribe(() => {
      const currentToken = localStorage.getItem('token');
      if (currentToken !== this.lastToken) {
        this.lastToken = currentToken; // Update the last known token
        if (this.isLoggedIn()) {
          this.fetchUserInfo(); // Fetch user info if a new or changed valid token is found
        }
      }
      if (!this.isLoggedIn()) {
        this.userInfo = null; // Clear user info if logged out
      }
    });
  }

  isLoggedIn(): boolean {
    const token = this.lastToken;
    if (!token) {
      return false;
    }
    
    try {
      const decoded: any = jwtDecode(token);
      return decoded.exp > Date.now() / 1000;
    } catch (error) {
      console.error("Error decoding token:", error);
      return false;
    }
  }

  signOut(): void {
    localStorage.removeItem('token');
    this.router.navigate(['/']);
    this.userInfo = null; // Clear user info on sign out
    this.AuthService.logout();
    // No need to stop polling, as it will automatically adjust based on token presence
  }

  fetchUserInfo(): void {
    this.isLoadingProfile = true;
    this.apiService.getUserInfo().subscribe({
      next: (info) => {
        this.userInfo = info;
        this.isLoadingProfile = false;
      },
      error: (error) => {
        console.error('Error fetching user info:', error);
        // Optionally handle user info fetch errors, e.g., by logging out the user
      }
    });
  }
}
